import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

/**
 * Non-blocking inline banner shown at the bottom of the screen during demo sessions.
 * Does NOT block any functionality — purely informational.
 */
const DemoBanner = () => (
  <div className="fixed bottom-0 left-0 right-0 z-40 bg-primary/95 backdrop-blur-sm text-primary-foreground py-2.5 px-4 text-center text-sm font-medium shadow-lg">
    <div className="flex items-center justify-center gap-2 flex-wrap">
      <Sparkles className="h-4 w-4 flex-shrink-0" />
      <span>You're exploring Arrowlink in demo mode.</span>
      <Link
        to="/pricing"
        className="inline-flex items-center gap-1 underline underline-offset-2 hover:opacity-90 font-semibold"
      >
        Sign up free to keep your work and unlock all features
        <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  </div>
);

export default DemoBanner;
